import { LoadingSkeleton } from "../components/feedback/LoadingSkeleton";
import { StatusBanner } from "../components/feedback/StatusBanner";
import { Button } from "../components/ui/Button";
import { useSession } from "./session";

/**
 * What a guarded screen shows before the API has said who is signed in, or
 * when it could not be reached. Neither is a refusal, so neither is drawn as
 * one.
 */
export function SessionPendingScreen() {
  const { refresh, session } = useSession();

  if (session.kind === "unavailable") {
    return (
      <StatusBanner
        action={
          <Button onClick={() => void refresh()} variant="secondary">
            Try again
          </Button>
        }
        description="Check this device's connection. Nothing has been lost; sign-in picks up where it was once BurgePOS answers."
        title="BurgePOS can't be reached"
        tone="warning"
      />
    );
  }
  return <LoadingSkeleton />;
}
